import '../scss/main.scss';

import Header from './components/Header';
import EagerlyScrollSnap from './components/EagerlyScrollSnap/eagerly-scroll-snap';
import EagerlyImageMove from './components/EagerlyImageMove';
import EagerlyVideoPlayer from './modules/videoplayer';
import Swiper from './modules/swiper';

window.addEventListener(
  'load',
  () => {
    // initialize modules //

    // Header
    document.querySelectorAll('.js-header').forEach(
      (el) =>
        new Header(el, {
          toggle: '.js-nav-toggle',
          overlay: '.js-nav-overlay',
          showItems: '.js-show-item',
          fadeInItems: '.js-fade-in',
        })
    );

    // EagerlyScrollSnap
    document.querySelectorAll('.js-eagerly-scroll-snap').forEach((el) => new EagerlyScrollSnap(el, true));

    // EagerlyImageMove
    document.querySelectorAll('.js-eagerly-image-move').forEach((el) => new EagerlyImageMove(el));

    // EagerlyVideoPlayer
    document.querySelectorAll('.js-player').forEach((el) => new EagerlyVideoPlayer(el));
  },
  false
);
